import { useAccountRateFieldApi } from '../api';

export const useAccountsRatesTAccTAPreferred = () => {
  const response = useAccountRateFieldApi({
    field: 'T_ACC.TA_PREFERRED',
  });
  return response;
};
